import { FC, useState } from 'react'

import styled from 'styled-components'
import { Divider } from 'antd'

import { ManualMatchingCuratorItem } from '../ManualMatchingCuratorItem'
import { ManualMatchingPlaylistItem } from '../ManualMatchingPlaylistItem'
import { ShowAllPlaylistsButton } from '../CuratorPlaylistsItem/ShowAllPlaylistsButton'

interface Playlist {
  id: number
  playlistName: string
  followers: number
  playlistCover?: string
  playlistUrl?: string
}

export interface ManualMatchingItemProps {
  curatorName: string
  playlistsCount: number
  amountPerSubmission: string
  avatarUrl?: string | null
  playlists: Playlist[]
  checked?: boolean
  onCheckboxChange?: (checked: boolean) => void
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 24px 16px 8px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
  width: 600px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: 358px;
  }
`

const StyledDivider = styled(Divider)`
  margin: 16px 0 4px;
  border-color: ${({ theme }) => theme.color.lightGrey};
`

const PlaylistsSection = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 32px;
`

const ButtonSection = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`

const MAX_PLAYLISTS_DISPLAYED = 3

export const ManualMatchingItem: FC<ManualMatchingItemProps> = ({
  curatorName,
  playlistsCount,
  amountPerSubmission,
  avatarUrl,
  playlists,
  checked,
  onCheckboxChange,
}) => {
  const [showAll, setShowAll] = useState(false)

  const hasMoreThanThreePlaylists = playlists.length > MAX_PLAYLISTS_DISPLAYED
  const displayedPlaylists =
    !showAll && hasMoreThanThreePlaylists
      ? playlists.slice(0, MAX_PLAYLISTS_DISPLAYED)
      : playlists
  return (
    <Container>
      <ManualMatchingCuratorItem
        curatorName={curatorName}
        playlistsCount={playlistsCount}
        amountPerSubmission={amountPerSubmission}
        avatarUrl={avatarUrl}
        checked={checked}
        onCheckboxChange={onCheckboxChange}
      />

      <StyledDivider dashed />

      <PlaylistsSection>
        {displayedPlaylists.map((playlist) => (
          <ManualMatchingPlaylistItem
            key={playlist.id}
            playlistName={playlist.playlistName}
            playlistCoverUrl={playlist.playlistCover}
            playlistUrl={playlist.playlistUrl}
            followers={playlist.followers}
          />
        ))}
      </PlaylistsSection>
      {hasMoreThanThreePlaylists && (
        <ButtonSection>
          <ShowAllPlaylistsButton
            showAll={showAll}
            onClick={() => setShowAll(!showAll)}
          />
        </ButtonSection>
      )}
    </Container>
  )
}
